module.exports = __webpack_public_path__ + "static/media/perpetual.070415cd.jpg";